// Entry point for the build script in your package.json
import "@hotwired/turbo-rails";
import "./controllers";

// import "foundation-sites"
import "foundation-sites/js/foundation/foundation";
import "foundation-sites/js/foundation/foundation.abide";
import "foundation-sites/js/foundation/foundation.clearing";
import "foundation-sites/js/foundation/foundation.equalizer";
import "foundation-sites/js/foundation/foundation.interchange";
import "foundation-sites/js/foundation/foundation.offcanvas";
import "foundation-sites/js/foundation/foundation.slider";
import "foundation-sites/js/foundation/foundation.tab";
import "foundation-sites/js/foundation/foundation.tooltip";

import "slick-carousel/slick/slick";

document.addEventListener("turbo:load", () => {
  $(document).foundation();

  $('#homepage-slider').not(".slick-initialized").slick({
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 1200,
    arrows: false,
    // appendArrows: $('#homepage-slider .lead-pic'),
    // fade: true,
    // cssEase: 'linear',
    // adaptiveHeight: true
  });
  $('#gallery-slider').not(".slick-initialized").slick({
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 1200,
    arrows: false,
    // fade: true,
    // cssEase: 'linear',
    // adaptiveHeight: true
  });
  $('#toggle-search').on('click', function() {
    $('#menu-and-search').slideToggle("normal", function() {$('#search').focus();});
    return false;
  });
  $('#toggle-search2').on('click', function() {
    // $('#search-medium').slideToggle("normal", function() {$('#search').focus();});
    $('#search-medium').animate({width: 'toggle'}, "normal", "swing", function() {$('#search').focus();});
    return false;
  });
});
